// components/LoginPage.jsx
// Full-screen login — matches CW Expense Manager aesthetic

import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth';
import logo from '../assets/CT.png';

export default function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-base)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Dot-grid background */}
      <div className="blueprint-grid" />

      {/* Ambient glow */}
      <div style={{
        position: 'absolute',
        top: '18%',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '500px',
        height: '400px',
        background: 'radial-gradient(ellipse, var(--accent-glow), transparent 70%)',
        pointerEvents: 'none',
        zIndex: 0,
      }} />

      <div style={{
        position: 'relative',
        zIndex: 1,
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-xl)',
        padding: '3rem 2.5rem',
        textAlign: 'center',
        width: '100%',
        maxWidth: '380px',
        boxShadow: '0 24px 64px rgba(0, 0, 0, 0.4)',
        animation: 'fadeUp 0.6s cubic-bezier(0.22, 1, 0.36, 1) both',
      }}>
        {/* Top accent line */}
        <div style={{
          position: 'absolute',
          top: 0,
          left: '20%',
          right: '20%',
          height: '2px',
          borderRadius: '0 0 2px 2px',
          background: 'linear-gradient(90deg, transparent, var(--accent-bold), transparent)',
          opacity: 0.6,
        }} />

        <img
          src={logo}
          alt="CNTD Tech"
          style={{
            height: '44px',
            width: 'auto',
            marginBottom: '1.75rem',
          }}
        />

        <div style={{
          fontFamily: 'var(--font-mono)',
          fontSize: '0.65rem',
          letterSpacing: '0.25em',
          textTransform: 'uppercase',
          color: 'var(--text-muted)',
          marginBottom: '0.4rem',
        }}>
          Connected Technologies
        </div>

        <h1 style={{
          fontFamily: 'var(--font-display)',
          fontWeight: 700,
          fontSize: '1.6rem',
          letterSpacing: '-0.01em',
          color: 'var(--text-primary)',
          marginBottom: '0.5rem',
          lineHeight: 1.2,
        }}>
          Dashboard Hub
        </h1>

        <div style={{
          width: '36px',
          height: '3px',
          background: 'var(--accent-bold)',
          margin: '0 auto 2rem',
          borderRadius: '2px',
        }} />

        <button
          onClick={handleLogin}
          style={{
            width: '100%',
            padding: '0.75rem 1.25rem',
            background: 'var(--accent-deep)',
            border: 'none',
            borderRadius: 'var(--radius)',
            color: '#fff',
            fontFamily: 'var(--font-body)',
            fontSize: '0.8rem',
            fontWeight: 600,
            letterSpacing: '0.04em',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 16px rgba(99, 102, 241, 0.25)',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'var(--accent-bold)';
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 6px 24px rgba(99, 102, 241, 0.35)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'var(--accent-deep)';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 16px rgba(99, 102, 241, 0.25)';
          }}
        >
          Sign in with Microsoft
        </button>

        <p style={{
          marginTop: '1rem',
          fontFamily: 'var(--font-mono)',
          fontSize: '0.6rem',
          color: 'var(--text-muted)',
          letterSpacing: '0.06em',
        }}>
          Use your cntdtech.com Microsoft account
        </p>
      </div>
    </div>
  );
}
